import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import accountService from '../../../services/accountService';

export interface UserState {
  affiliateLink: string;
  seenPinExtensionModal: boolean;
}

export const sawPinExtensionModal = createAction('account/sawPinExtensionModal');

export const getAffiliateLinkFromId = createAsyncThunk('account/getAffiliateLink', async (query: { userId: string }) => {
  const link = await accountService.getAffiliateLinkFromId(query.userId);

  return link;
});
